export const CHART_COLORS = {
  ACTIVE: '#DCCA28', 
  INACTIVE: '#E5E7EB', 
  MEAN: '#F97316', 
};

export const calculateFinalMean = (monthlyValues: number[], annualMean?: number): number => {
  return annualMean ?? (
    monthlyValues.reduce((a, b) => a + b, 0) / (monthlyValues.length || 1)
  );
};

export const formatChartData = (
  monthlyValues: number[], 
  activeIndex: number, 
  finalMean: number
) => {
  const data = monthlyValues.map((value, index) => ({
    y: value,
    color: (activeIndex === -1 || index === activeIndex) 
      ? CHART_COLORS.ACTIVE 
      : CHART_COLORS.INACTIVE
  }));

  return [
    ...data,
    {
      y: parseFloat(finalMean.toFixed(1)),
      color: CHART_COLORS.MEAN,
      name: 'Média'
    }
  ];
};